const inventoryTypes = {
  FETCHING: "FETCHING",
  FETCH_ROOM_INVENTORY: "FETCH_ROOM_INVENTORY",
  FETCH_ROOMS: "FETCH_ROOMS",
};

export default inventoryTypes;
